module.exports = __webpack_public_path__ + "img/learning-forest_brand_development.ee90e30f.jpg";